import { appRoutes } from 'features/app/routes/paths';

export const financePaths = Object.freeze({
  static: {
    balanceAndTopUp: `${appRoutes.static.root}/balance-and-top-up`,
  },
});
